import MobileDetect from 'mobile-detect'

export default function(userAgent) {
  return new MobileDetect(userAgent)
}

const ua = navigator.userAgent

export const isIos = /(iPhone|iPad|iPod|iOS)/i.test(ua)
export const isAndroid = /(Android)/i.test(ua)
export const isWechat = /MicroMessenger\/([\d\.]+)/i.test(ua)
